<template>
  <div>
    <div class="das_top_cont inv_dl_root">
      <div class="history_box">
        <div class="accountright_cont_box inv_dl_root_top_box">
          <div class="flex_center_between_box inv_dl_root_top_header" style="">
            <h2 class="inv_dl_root_title">
              {{ $t("BillingandPayment.InvoiceInfo") }}
            </h2>

            <div style="display: flex">
              <button
                class="btn_blue flex_center btn_eee change_btn inv_dl_root_button"
                v-if="Edit"
                @click="Edit = !Edit"
              >
                {{ $t("ContactInfo.Edit") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center inv_dl_root_button inv_dl_root_top_button"
                  @click="SubmitFrom('ruleForm')"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray inv_dl_root_button inv_dl_root_top_button"
                  @click="(Edit = !Edit), getInvoiceInformationList()"
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="CompanyName">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.CompanyName"
                      :placeholder="$t('BillingandPayment.CompanyName')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.CompanyName"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item label="" prop="PhoneNumber">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.PhoneNumber"
                      :placeholder="$t('BillingandPayment.PhoneNumber')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.PhoneNumber"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>

              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item>
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.CompanyID"
                      :placeholder="$t('BillingandPayment.CompanyID')"
                    >
                      <!-- <span slot="prefix" class="prefixRed">*</span> -->
                    </el-input>
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="Email">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.Email"
                      :placeholder="$t('BillingandPayment.Email')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.Email"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="Region">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.Region"
                      :placeholder="$t('BillingandPayment.CountryRegion')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.Region"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="BankAccountHolder">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.BankAccountHolder"
                      :placeholder="
                        $t('BillingandPayment.BankAccountHolderName')
                      "
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.BankAccountHolder"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="AddressLine">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.AddressLine"
                      :placeholder="$t('BillingandPayment.AddressLine')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.AddressLine"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="BankName">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.BankName"
                      :placeholder="$t('BillingandPayment.BeneficiaryBankName')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.BankName"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="AddressLine2">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.AddressLine2"
                      :placeholder="$t('BillingandPayment.AddressLine')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.AddressLine2"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="CODE">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.CODE"
                      :placeholder="$t('BillingandPayment.SWIFTCODE')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.CODE"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="City">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.City"
                      :placeholder="$t('BillingandPayment.City')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.City"
                        class="prefixRed"
                        >*</span
                      >
                    </el-input>
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="AccountNumber">
                    <el-input
                      class="inline-input"
                      :disabled="Edit"
                      clearable
                      v-model="ruleForm.AccountNumber"
                      :placeholder="$t('BillingandPayment.AccountNumber')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.AccountNumber"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="ZipCode">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.ZipCode"
                      :placeholder="$t('BillingandPayment.ZipCode')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.ZipCode"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="BeneficiaryBankAddress">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.BeneficiaryBankAddress"
                      :placeholder="
                        $t('BillingandPayment.BeneficiaryBankAddress')
                      "
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.BeneficiaryBankAddress"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="FirstName">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.FirstName"
                      :placeholder="$t('BillingandPayment.FirstName')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.FirstName"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="ABA">
                    <el-input
                      class="inline-input"
                      :disabled="Edit"
                      clearable
                      v-model="ruleForm.ABA"
                      :placeholder="$t('BillingandPayment.ABA')"
                    >
                      <span slot="prefix" v-if="!ruleForm.ABA" class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="information-content">
                <div class="sel_box computer_right_cont_box">
                  <el-form-item prop="LastName">
                    <el-input
                      :disabled="Edit"
                      class="inline-input"
                      clearable
                      v-model="ruleForm.LastName"
                      :placeholder="$t('BillingandPayment.LastName')"
                    >
                      <span
                        slot="prefix"
                        v-if="!ruleForm.LastName"
                        class="prefixRed"
                        >*</span
                      ></el-input
                    >
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div
          class="accountright_cont_box mt10 account_input"
          style="display: flex; flex-direction: column; padding-bottom: 0"
        >
          <div class="flex_center_between_box spec_title" style="">
            <h2 class="inv_dl_root_title">
              {{ $t("BillingandPayment.InvoiceInfo") }}
            </h2>
            <div style="display: flex">
              <button
                class="flex_center inv_dl_root_button inv_dl_root_bottom_button"
                :class="Dowload.length == 0 ? 'btn_disabled' : 'btn_blue'"
                :disabled="Dowload.length == 0"
                style="margin-right: 10px"
                @click="ReportError = true"
              >
                <span> {{ $t("BillingandPayment.Contactus") }}</span>
                <!-- <a v-else style="color: #fff;" :href="'mailto:service@csibizinfo.com?subject=information need to correct&body=Customer service, hello: %0D%0Aand If you have any questions about the selected single invoice or multiple invoices, please %0D%0Aand enter your questions below'+Dowload[0]?.email+Dowload[0]?.createTime+Dowload[0]?.paymentAmount+'%0D%0Aand Please help to handle it as soon as possible. thank you' ">
            
            </a> -->
              </button>
              <button
                class="flex_center inv_dl_root_button inv_dl_root_bottom_button"
                @click="getInvoicePdfAddress()"
                :class="Dowload.length == 0 ? 'btn_disabled' : 'btn_blue'"
                :disabled="Dowload.length == 0"
              >
                {{ $t("BillingandPayment.DownloadInvoice") }}
              </button>
            </div>
          </div>
          <div
            class="his_sel_box common_checkbox"
            style="width: 100%; display: flex; flex-direction: column; flex: 1"
          >
            <el-table
              class="spec_table inv_dl_root_bottom_table"
              :data="yourUsagelist"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              empty-text="No Data"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="selectableRows"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('BillingandPayment.Date')"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="paymentAmount"
                :label="$t('BillingandPayment.UserAccount')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.email }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="paymentAmount"
                :label="$t('BillingandPayment.PaymentAmount')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div class="table-content" style="">
                    {{ scope.row.paymentAmount }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                <span
                  class="foundOverNum"
                  :style="{ color: $store.state.app.themeColor }"
                  >&nbsp;{{ page.total | FilterNum }}&nbsp;</span
                >
                results for "{{ $t("BillingandPayment.InvoiceInfo") }}"
              </div>
            </div>
            <!-- <div class="show_AllHeight" v-show="this.page.total>this.page.pageSize"  style="text-align: center; padding-top: 20px" v-if="yourUsagelist.length!=0">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    <Reporterror
      :showReport="ReportError"
      @closeReportDialog="closeDialog($event)"
    ></Reporterror>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getInvoiceInformation,
  saveInvoiceInformation,
  updateInvoiceInformation,
  getInvoicePdfAddress,
  getUserRechargesPage,
} from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";
import Reporterror from "../../../components/reportProblems/index.vue";
import Page from "@/components/page/index.vue";

export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Reporterror,
    Page,
  },
  computed: {
    rules() {
      return {
        CompanyName: [
          {
            required: true,
            message: this.$t("BillingandPayment.CompanyName"),
            trigger: "blur",
          },
        ],

        PhoneNumber: [
          {
            required: true,
            message: this.$t("BillingandPayment.PhoneNumber"),
            trigger: "blur",
          },
        ],
        Email: [
          {
            required: true,
            message: this.$t("BillingandPayment.Email"),
            trigger: "blur",
          },
        ],
        Region: [
          {
            required: true,
            message: this.$t("BillingandPayment.CountryRegion"),
            trigger: "blur",
          },
        ],
        BankAccountHolder: [
          {
            required: true,
            message: this.$t("BillingandPayment.BankAccountHolderName"),
            trigger: "blur",
          },
        ],
        BankName: [
          {
            required: true,
            message: this.$t("BillingandPayment.BeneficiaryBankName"),
            trigger: "blur",
          },
        ],
        AddressLine: [
          {
            required: true,
            message: this.$t("BillingandPayment.AddressLine"),
            trigger: "blur",
          },
        ],
        AddressLine2: [
          {
            required: true,
            message: this.$t("BillingandPayment.AddressLine"),
            trigger: "blur",
          },
        ],
        CODE: [
          {
            required: true,
            message: this.$t("BillingandPayment.SWIFTCODE"),
            trigger: "blur",
          },
        ],
        City: [
          {
            required: true,
            message: this.$t("BillingandPayment.City"),
            trigger: "blur",
          },
        ],
        AccountNumber: [
          {
            required: true,
            message: this.$t("BillingandPayment.AccountNumber"),
            trigger: "blur",
          },
        ],
        ZipCode: [
          {
            required: true,
            message: this.$t("BillingandPayment.ZipCode"),
            trigger: "blur",
          },
        ],
        BeneficiaryBankAddress: [
          {
            required: true,
            message: this.$t("BillingandPayment.BeneficiaryBankAddress"),
            trigger: "blur",
          },
        ],
        FirstName: [
          {
            required: true,
            message: this.$t("BillingandPayment.FirstName"),
            trigger: "blur",
          },
        ],
        ABA: [
          {
            required: true,
            message: this.$t("BillingandPayment.ABA"),
            trigger: "blur",
          },
        ],
        LastName: [
          {
            required: true,
            message: this.$t("BillingandPayment.LastName"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  data() {
    return {
      reLoginVis: false,
      ReportError: false,
      value1: "",
      CategoryVal: "",
      ruleForm: {
        CompanyName: "",
        PhoneNumber: "",
        CompanyID: "",
        Email: "",
        Region: "",
        BankAccountHolder: "",
        AddressLine: "",
        AddressLine2: "",
        CODE: "",
        City: "",
        BankName: "",
        AccountNumber: "",
        ZipCode: "",
        BeneficiaryBankAddress: "",
        FirstName: "",
        ABA: "",
        LastName: "",
        countryCode: "",
        userId: "",
      },
      yourUsagelist: [],
      window: window,
      Edit: true,
      page: {
        pageSize: 5,
        pageNo: 1,
        total: 0,
      },
      Dowload: [],
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.getInvoiceInformationList();
    this.getgetUserActionLogPage();
  },

  methods: {
    closeDialog(value) {
      this.ReportError = value;
    },
    getgetUserActionLogPage() {
      getUserRechargesPage({
        // email: this.CategoryVal,
        // actualAmount: this.CategoryVal1,
        // startTime: this.datePicker == null ? "" : this.datePicker[0],
        // endTime: this.datePicker == null ? "" : this.datePicker[1],
        hasUserInvoiceId: false,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.yourUsagelist = res.data.rows;
          this.page.total = res.data.total;
        } else {
          this.yourUsagelist = [];
        }
      });
    },
    // 发票信息
    getInvoiceInformationList() {
      getInvoiceInformation()
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = {
              CompanyName: res.data.companyName,
              PhoneNumber: res.data.phoneNumber,
              CompanyID: res.data.companyId,
              Email: res.data.email,
              Region: res.data.countryRegion,
              BankAccountHolder: res.data.bankHolderName,
              AddressLine: res.data.addressLine1,
              AddressLine2: res.data.addressLine2,
              CODE: res.data.swiftCode,
              City: res.data.city,
              BankName: res.data.beneficiaryBankName,
              AccountNumber: res.data.accountNumber,
              ZipCode: res.data.zipCode,
              BeneficiaryBankAddress: res.data.beneficiaryBankAddress,
              FirstName: res.data.firstName,
              ABA: res.data.aba,
              LastName: res.data.lastName,
              userId: res.data.userId,
              countryCode: "US",
            };
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    SubmitFrom(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let submit = {
            userId: this.ruleForm.userId,
            companyName: this.ruleForm.CompanyName,
            companyId: this.ruleForm.CompanyID,
            countryRegion: this.ruleForm.Region,
            addressLine1: this.ruleForm.AddressLine,
            addressLine2: this.ruleForm.AddressLine2,
            city: this.ruleForm.City,
            zipCode: this.ruleForm.ZipCode,
            firstName: this.ruleForm.FirstName,
            lastName: this.ruleForm.LastName,
            phoneNumber: this.ruleForm.PhoneNumber,
            countryCode: this.ruleForm.countryCode,
            email: this.ruleForm.Email,
            bankHolderName: this.ruleForm.BankAccountHolder,
            beneficiaryBankName: this.ruleForm.BankName,
            swiftCode: this.ruleForm.CODE,
            accountNumber: this.ruleForm.AccountNumber,
            beneficiaryBankAddress: this.ruleForm.BeneficiaryBankAddress,
            aba: this.ruleForm.ABA,
          };
          if (this.ruleForm.userId) {
            updateInvoiceInformation(submit).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.Edit = true;
              }
            });
          } else {
            saveInvoiceInformation(submit).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.Edit = true;
              }
            });
          }
          // alert('submit!');
        } else {
          return false;
        }
      });
      // Edit = !Edit
    },
    handleSelectionChange(val) {
      this.Dowload = val;
    },
    selectableRows(row, index) {
      return row.actualAmount;
    },
    // 下载发票
    getInvoicePdfAddress() {
      let userInvoiceIdArr = [];
      this.Dowload.forEach((item, index) => {
        userInvoiceIdArr.push(item.id);
      });

      getInvoicePdfAddress({ ids: userInvoiceIdArr.join(",") }).then((res) => {
        if (res.code == 200) {
          window.open(res.data, "_blank");
          window.location.reload();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage();
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;

      this.getgetUserActionLogPage();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 12px;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 16px;
  height: 16px;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 9px;
  font-size: 16px;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 4px;
}

.item_txt {
  font-size: 22px;
  text-align: center;
}

.cont_m {
  margin-top: 26px;
  margin-bottom: 70px;
}

.country_box {
  margin-top: 52px;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 18px;
}

.title_txt {
  font-size: 14px;
  font-family: "Arial Bold";
}

.title_txt img {
  width: 18px;
  margin-right: 7px;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  background: #1290c9;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 18px;
}

.btn_blue img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.sel_box {
  width: 40%;
  height: 36px;
  margin-right: 22px;
}

.sel_box /deep/ .el-input__inner {
  width: 100%;
  min-width: 530px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: "Arial";
  font-size: 16px;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 18px;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 54px;
  height: 54px;
  line-height: 68px;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: center;
}

.top_tab {
  margin-top: 35px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

.last-colmun {
  padding: 25px 0;
  border-bottom: 1px solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -26px;
  right: 0;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 26px !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 18px;
  color: #8c939d;
  width: 62px;
  height: 62px;
  line-height: 62px;
  text-align: center;
}

/deep/ .avatar {
  width: 62px;
  height: 62px;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 3px;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 14px;
  margin-left: -4px;
  color: #1a2332;
  /* float: left; */
  line-height: 28px;
  position: relative;
  left: 47%;
}

.information-content {
  display: flex;
  margin-bottom: 22px;
  /* margin-bottom: 1.7857142857142858rem; */
}

.btn_eee {
  background: #eee;
  color: #1a2332;
}

/deep/ .prefixRed {
  color: red;
  margin-left: 9px;
}

/deep/ .el-input__inner {
  padding-left: 20px !important;
}

.account_input .spec_title {
  margin-bottom: 16px;
}

.inv_dl_root_title {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 24px;
  color: #1290c9;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}

.inv_dl_root_top_header {
  margin-bottom: 20px;
}

.inv_dl_root_top_box {
  margin-bottom: 20px;
}

.inv_dl_root_button {
  width: max-content;
  height: 40px;
  padding: 0 15px;
  border-radius: 10px;
  font-family: "Arial";
  font-size: 18px;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}

.inv_dl_root_top_button:first-child,
.inv_dl_root_bottom_button:first-child {
  margin-right: 15px !important;
}

.inv_dl_root_bottom_table ::v-deep {
  height: auto;
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.inv_dl_root_bottom_table ::v-deep thead,
.inv_dl_root_bottom_table ::v-deep .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.inv_dl_root_bottom_table ::v-deep td,
.inv_dl_root_bottom_table ::v-deep td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.inv_dl_root_bottom_table
  ::v-deep
  .el-table__body-wrapper
  .el-table__row
  td:last-child,
.inv_dl_root_bottom_table ::v-deep .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.inv_dl_root_bottom_table::after {
  display: none !important;
}

.inv_dl_root_bottom_table.el-table {
  overflow: hidden;
}

.inv_dl_root_bottom_table ::v-deep .el-table__cell:first-child > .cell {
  padding-left: 20px !important;
}

.inv_dl_root_bottom_table
  ::v-deep
  .el-table__body-wrapper
  .el-table__cell:last-child
  > .cell {
  padding-right: 120px !important;
}

.inv_dl_root_bottom_table
  ::v-deep
  .el-table__header-wrapper
  th.el-table__cell:nth-last-child(2)
  > .cell {
  text-align: center;
  padding-right: 120px !important;
}

.inv_dl_root_bottom_table.el-table ::v-deep th.el-table__cell > .cell {
  font-family: "Arial bold";
}

.inv_dl_root_bottom_table.el-table ::v-deep .cell,
.inv_dl_root_bottom_table.el-table ::v-deep .cell .table-content {
  font-size: 18px !important;
  line-height: 24px;
  color: #1a2332;
  font-family: "Arial";
  text-align: left;
  font-style: normal;
}

.inv_dl_root_bottom_table.el-table ::v-deep .cell .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.inv_dl_root_bottom_table.el-table ::v-deep .cell .el-checkbox__inner::after {
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  background-image: none;
}

::v-deep input::-webkit-input-placeholder {
  color: #ccc !important;
}

@media screen and (max-width: 1920px) {
  .das_top_item .item_img img {
    width: 12px;
    height: 12px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 7px 0 7px;
  }

  .das_top_item .item_group {
    margin-left: 7px;
    font-size: 12px;
  }

  .das_top_item .item_lab {
    margin-top: 3px;
  }

  .item_txt {
    font-size: 16px;
  }

  .cont_m {
    margin-top: 20px;
    margin-bottom: 52px;
  }

  .country_box {
    margin-top: 40px;
  }

  .title {
    margin-bottom: 14px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 14px;
    margin-right: 5px;
  }

  .btn_blue {
    font-size: 14px;
  }

  .btn_blu {
    margin-right: 14px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .sel_box {
    margin-right: 16px;
    height: 28px;
  }

  .sel_box /deep/ .el-input__inner {
    width: 100%;
    min-width: 400px;
    height: 36px;
    border-radius: 7px;
    font-size: 16px;
  }

  .das_top_item {
    padding: 14px;
  }

  .das_top_item .item_img {
    width: 40px;
    height: 40px;
    line-height: 52px;
  }

  .das_top_item .item_title {
    font-size: 14px;
    margin: 7px 0 7px;
  }

  .top_tab {
    margin-top: 26px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -20px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 20px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 4px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 16px;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  ::v-deep .avatar {
    width: 48px;
    height: 48px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 22px;
  }

  .information-content {
    margin-bottom: 16px;
  }

  ::v-deep .prefixRed {
    margin-left: 4px;
  }

  ::v-deep .el-input__inner {
    padding-left: 16px !important;
  }

  .account_input .spec_title {
    margin-bottom: 15px;
  }

  .inv_dl_root_title {
    font-size: 20px;
    line-height: 40px;
  }

  .inv_dl_root_top_header {
    margin-bottom: 15px;
  }

  .inv_dl_root_top_box {
    margin-bottom: 15px;
  }

  .inv_dl_root_button {
    height: 30px;
    border-radius: 7px;
    font-size: 16px;
    line-height: 26px;
  }

  .inv_dl_root_bottom_table ::v-deep thead,
  .inv_dl_root_bottom_table ::v-deep .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .inv_dl_root_bottom_table ::v-deep td,
  .inv_dl_root_bottom_table ::v-deep td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .inv_dl_root_bottom_table ::v-deep .el-table__cell:first-child > .cell {
    padding-left: 15px !important;
  }

  .inv_dl_root_bottom_table
    ::v-deep
    .el-table__body-wrapper
    .el-table__cell:last-child
    > .cell {
    padding-right: 90px !important;
  }

  .inv_dl_root_bottom_table
    ::v-deep
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 90px !important;
  }

  .inv_dl_root_bottom_table.el-table ::v-deep .cell,
  .inv_dl_root_bottom_table.el-table ::v-deep .cell .table-content {
    font-size: 16px !important;
    line-height: 18px;
  }

  .inv_dl_root_bottom_table.el-table ::v-deep .cell .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }

  .sel_box ::v-deep .el-form-item__error {
    font-size: 14px;
    padding-top: 1px;
  }

  .sel_box ::v-deep .el-form-item__content {
    line-height: 32px;
  }

  .flex_center_between_box {
    align-items: center;
  }
}

@media screen and (max-width: 1439px) {
  .das_top_item .item_img img {
    width: 10px;
    height: 10px;
  }

  .das_top_item .item_title {
    font-size: 10px;
    margin: 6px 0 6px;
  }

  .das_top_item .item_group {
    margin-left: 6px;
    font-size: 10px;
  }

  .das_top_item .item_lab {
    margin-top: 3px;
  }

  .item_txt {
    font-size: 14px;
  }

  .cont_m {
    margin-top: 17px;
    margin-bottom: 48px;
  }

  .country_box {
    margin-top: 34px;
  }

  .title {
    margin-bottom: 12px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 12px;
    margin-right: 5px;
  }

  .btn_blue {
    font-size: 12px;
  }

  .btn_blu {
    margin-right: 12px;
  }

  .btn_blue img {
    width: 10px;
    height: 10px;
    margin-right: 3px;
  }

  .sel_box {
    margin-right: 14px;
    height: 24px;
  }

  .sel_box /deep/ .el-input__inner {
    width: 100%;
    min-width: 356px;
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .das_top_item {
    padding: 12px;
  }

  .das_top_item .item_img {
    width: 38px;
    height: 38px;
    line-height: 46px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .top_tab {
    margin-top: 24px;
  }

  .last-colmun {
    padding: 16px 0;
  }

  .dingwei {
    top: -17px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 17px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 3px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 14px;
    width: 42px;
    height: 42px;
    line-height: 42px;
  }

  ::v-deep .avatar {
    width: 42px;
    height: 42px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 18px;
  }

  .information-content {
    margin-bottom: 15px;
  }

  ::v-deep .prefixRed {
    margin-left: 2px;
  }

  ::v-deep .el-input__inner {
    padding-left: 14px !important;
  }

  .account_input .spec_title {
    margin-bottom: 10px;
  }

  .inv_dl_root_title {
    font-size: 16px;
    line-height: 26px;
  }

  .inv_dl_root_top_header {
    margin-bottom: 12px;
  }

  .inv_dl_root_top_box {
    margin-bottom: 12px;
  }

  .inv_dl_root_button {
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .inv_dl_root_bottom_table ::v-deep thead,
  .inv_dl_root_bottom_table ::v-deep .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .inv_dl_root_bottom_table ::v-deep td,
  .inv_dl_root_bottom_table ::v-deep td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .inv_dl_root_bottom_table ::v-deep .el-table__cell:first-child > .cell {
    padding-left: 12px !important;
  }

  .inv_dl_root_bottom_table
    ::v-deep
    .el-table__body-wrapper
    .el-table__cell:last-child
    > .cell {
    padding-right: 80px !important;
  }

  .inv_dl_root_bottom_table
    ::v-deep
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 80px !important;
  }

  .inv_dl_root_bottom_table.el-table ::v-deep .cell,
  .inv_dl_root_bottom_table.el-table ::v-deep .cell .table-content {
    font-size: 14px !important;
    line-height: 16px;
  }

  .inv_dl_root_bottom_table.el-table ::v-deep .cell .el-checkbox__inner {
    width: 12px;
    height: 12px;
  }

  .sel_box ::v-deep .el-form-item__error {
    padding-top: 2px;
  }

  .sel_box ::v-deep .el-form-item__content {
    line-height: 32px;
  }
}

/* @media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
} */
</style>
